var ModaleTaille = ["sm", "md", "lg"];
export var ModaleDefaultProps = {
    taille: "md"
};
